<template>
  <button class="c_button" @click="tapButton">
    <span :class="[this.icon]" v-if="this.icon"></span>&nbsp;{{ this.label }}
  </button>
</template>

<script>
import '@/styles/color.css'

export default {
  name: 'UIButton',
  props: {
    label: { type: String, required: true },
    icon: { type: String, required: false }
  },
  methods: {
    tapButton() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.c_button {
  width: 100%;
  height: 44px;
  background-color: var(--accent-color);
  font-family: 'HiraKakuPro-W6';
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  letter-spacing: 0.8px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  outline: none;
  appearance: none;
}
.c_button_border .center {
  margin: auto;
  display: block;
}
.c_button_border:focus {
  outline: none;
}
</style>
